import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { FreezeDriedRecipes } from 'features/Recipes/FreezeDriedRecipes'
import Script from 'next/script'
export default function RecipesPage() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Premium Freeze-Dried Raw Dog Food Recipes | We Feed Raw",
  "url": "https://wefeedraw.com/recipes/freeze-dried-raw",
  "description": "Explore our selection of freeze-dried raw dog food recipes made with premium ingredients. Formulated by PhD Nutrition Experts, freeze-dried to maintain all the benefits of raw nutrition.",
  "mainEntity": {
    "@type": "ItemList",
    "itemListElement": [
      {
        "@type": "Recipe",
        "name": "Beef Recipe",
        "description": "A highly-palatable recipe that's complete + balanced to boost heart and immune system function.",
        "image":
          "https://wefeedraw.com/assets/recipes/freezeDried/product/25oz-freeze-dried-beef-pouch.webp",
        "url": "https://wefeedraw.com/recipes/freeze-dried-raw-beef"
      },
      {
        "@type": "Recipe",
        "name": "Chicken Recipe",
        "description": "A complete + balanced nutrient-dense recipe packed with dog superfoods.",
        "image":
          "https://wefeedraw.com/assets/recipes/freezeDried/product/25oz-freeze-dried-chicken-pouch.webp",
        "url": "https://wefeedraw.com/recipes/freeze-dried-raw-chicken"
      }
    ]
  }
};

  const jsonLdString = JSON.stringify(schema)

  return (
    <>
      <Head>
        <title>{t('recipes-overview:freeze-dried-page-title')}</title>
        <meta name="title" content={t('recipes-overview:freeze-dried-meta-title')} />
        <meta name="description" content={t('recipes-overview:freeze-dried-meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/recipes/freeze-dried-raw" />
        <script
          id="schema-script"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: jsonLdString }}
        />
      </Head>

      <main>
        <FreezeDriedRecipes />
      </main>
    </>
  )
}
